import EasetechLogoSpinner from "@/components/easetech-logo-spinner/EasetechLogoSpinner"
import FormItemDivider from "@/components/form-item/FormItemDivider"
import Typography from "@/components/typography/Typography"
import { Col, Row } from "antd"
import { FC } from "react"
import "./EasetechSpinner.less"

const { Paragraph } = Typography

export type EasetechSpinnerContent = {
  boldText?: string
  regularText?: string
}

export type EasetechSpinnerProps = {
  content: EasetechSpinnerContent
  isFormDivide?: boolean
}

const EasetechSpinner: FC<EasetechSpinnerProps> = ({ content, isFormDivide = true }) => {
  return (
    <div className={"easetech-spinner-wrapper"}>
      <EasetechLogoSpinner />

      <Row justify={"center"}>
        <Col span={16}>
          <Paragraph style={{ paddingTop: 24 }} weight={"w500"} size={"md"} color={"white"}>
            {content.boldText}
          </Paragraph>
          {isFormDivide && <FormItemDivider marginBottom={0} />}
          <Paragraph style={{ paddingTop: 12 }} weight={"w400"} size={"sm"} color={"white"}>
            {content.regularText}
          </Paragraph>
        </Col>
      </Row>
    </div>
  )
}

export default EasetechSpinner
